<template>
  <div>
    <img src="/static/img/assets/fbpay_logo.JPG" style="max-width: 200px; width: 100%" alt />
    <div class="mt-3">
      {{
        $t(
          "A payment process via Messenger, which connects to renowned banks' application, offers your customers a convenient purchases without attaching the receipt."
        )
      }}
      <a
        href="https://blog.zwiz.ai/%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%84%E0%B8%A3%E0%B9%80%E0%B8%9E%E0%B8%B4%E0%B9%88%E0%B8%A1%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A-paydii-%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%99/"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('How to use') }}?
      </a>
      <span> {{ $t('or') }} </span>
      <a
        href="https://secure.facebook.com/settings?tab=payments&section=pages_onboarding_landing_page&source=zwiz_web_p_payment_setting"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('Register Facebook Pay') }}
      </a>
    </div>

    <v-layout wrap>
      <v-flex xs12 v-if="fbpayStatus == null">
        <v-btn @click="toggleStatus" color="primary" depressed class="mx-0">{{
          $t('Turn on/off Facebook Pay')
        }}</v-btn>
      </v-flex>
      <template v-else>
        <v-flex xs12 sm6>{{ $t('Turn on/off Facebook Pay') }}</v-flex>
        <v-flex xs12 sm6 class="text-xs-left text-sm-right">
          <label
            class="toggle-switch small"
            style="margin-top: 10px; margin-bottom: 10px; vertical-align: bottom"
          >
            <input
              :disabled="loading"
              type="checkbox"
              :checked="fbpayStatus"
              @change="toggleStatus()"
            />
            <span class="toggle-slider lever round"></span>
          </label>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  data() {
    return {
      fbpayStatus: null,
      loading: false
    }
  },
  mounted() {
    this.fbpayStatus = this.selectedBot.fbpay_status
  },
  components: {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  methods: {
    savefbpaystatus(status) {
      var vm = this
      var data = {
        pageid: this.selectedBot.pageid,
        fbpay_status: status,
        access_token: this.selectedBot.page_access_token
      }
      // console.log(data)
      return new Promise((resolve, reject) => {
        api.savefbpaystatus(data, async function (error, response) {
          if (error) {
            vm.fbpayStatus = status

            return reject(error)
          } else {
            resolve(response)
          }
        })
      })
    },
    async toggleStatus() {
      this.loading = true
      if (this.selectedBot) {
        this.$store.dispatch('loading')
        var oldstatus = this.fbpayStatus
        var status = this.fbpayStatus == null ? true : !this.fbpayStatus
        try {
          var response = await this.savefbpaystatus(status)
          this.$store.dispatch('loading')
          await this.$swal.fire({
            title: this.$t('Success'),
            type: 'success',
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })
          this.fbpayStatus = status
        } catch (error) {
          this.fbpayStatus = oldstatus
          this.$store.dispatch('loading')
          await this.$swal.fire({
            type: 'error',
            text: this.$t('Unable to activate Facebook Pay'),
            footer: `<a href="https://blog.zwiz.ai/%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%84%E0%B8%A3%E0%B9%80%E0%B8%9E%E0%B8%B4%E0%B9%88%E0%B8%A1%E0%B8%A3%E0%B8%B0%E0%B8%9A%E0%B8%9A-paydii-%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%A3%E0%B9%89%E0%B8%B2%E0%B8%99/" target="_blank">
                    ${this.$t('See the instruction in order to sign up for Facebook Pay')}
                    </a>`
          })
        }
        await this.$store.dispatch('updateBotDetail')
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/FbpayPayment.vue